/* eslint one-var: [0]*/
/* eslint max-len: [0]*/
/* eslint max-params: [0]*/
/* eslint complexity: [0]*/
/* eslint no-multi-assign: [0]*/

import Modernizr from 'modernizr';
import Barba from 'barba.js';
import SVGInjector from 'svg-injector';
import { cover, contain } from 'intrinsic-scale';
require( '../lib/jquery.scrolllock.js' );
require( '../lib/pace.min.js' );

const Utils = {

	isset( obj ){
		var i, 
			max_i; // eslint-disable-line
		if ( obj === undefined ) {
			return false;
		}
		for ( i = 1, max_i = arguments.length; i < max_i; i++ ) { // eslint-disable-line
			if ( obj[arguments[i]] === undefined ) { // eslint-disable-line
				return false;
			}
			obj = obj[arguments[i]]; // eslint-disable-line
		}

		return true;	    
	},

	initSliders() {

	},

	scrollLock( lock ){
		const _lock = typeof lock === 'undefined' ? 'auto' : lock,
			$html = jQuery( 'html' );

		if ( _lock === true ){
			if ( ! $html.hasClass( 'is-fixed' ) ){
				jQuery.scrollLock( true );
				$html.addClass( 'is-fixed' );
			}
		} else if ( _lock === false ) {
			if ( $html.hasClass( 'is-fixed' ) ){
				jQuery.scrollLock( false );
				$html.removeClass( 'is-fixed' );
			}
		} else if ( _lock === 'auto' ){
			if ( $html.hasClass( 'is-fixed' ) ){
				jQuery.scrollLock( false );
			} else {
				jQuery.scrollLock( true );
			}
			
			$html.toggleClass( 'is-fixed' );
		}
	},

	scrollDisable( disable ){
		const $body = jQuery( 'body' ),
			_disable = typeof disable !== 'undefined' ? disable : 'auto';

		if ( _disable === true ){
			$body.addClass( ' overflow-hidden ' );
		} else if ( _disable === false ) {
			$body.removeClass( ' overflow-hidden ' );
		} else if ( _disable === 'auto' ) {
			if ( $body.hasClass( ' overflow-hidden ' ) ) {
				$body.removeClass( ' overflow-hidden ' );
			} else {
				$body.addClass( ' overflow-hidden ' );
			}
		}
	},

	disableLinks( exceptContainer ){
		const $allLinks = jQuery( 'a[href]' );
		$allLinks.filter( ( index, el ) => ! jQuery( el ).closest( exceptContainer.selector ).length ).attr( 'disabled', true ).addClass( 'pointer-events-none' ).addClass( 'is-disabled' );
	},

	enableLinks(){
		const $allLinks = jQuery( 'a[href][disabled].is-disabled' );
		$allLinks.removeAttr( 'disabled' ).removeClass( 'pointer-events-none' ).removeClass( 'is-disabled' );
	},

	initImgCanvasFilter( event, element ){
		const self = this;

		if ( typeof element === 'undefined' ){
			const element = event.target; // eslint-disable-line
		}

		const imageContainer = jQuery( element ).parent(),
			image = jQuery( element ),
			canvas = imageContainer.find( 'canvas' ).get( 0 ),
			context = canvas.getContext( '2d' ),
			containerHeight = parseInt( window.getComputedStyle( imageContainer.get( 0 ), null ).getPropertyValue( 'height' ), 10 ),
			containerWidth = parseInt( window.getComputedStyle( imageContainer.get( 0 ), null ).getPropertyValue( 'width' ), 10 );

		canvas.width = containerWidth;
		canvas.height = containerHeight;
		context.clearRect( 0, 0, canvas.width, canvas.height );

		// Simulate Background-Size: Cover
		const { x, y, width, height } = cover( containerWidth, containerHeight, image.get( 0 ).naturalWidth, image.get( 0 ).naturalHeight );
		context.drawImage( image.get( 0 ), x, y, width, height ); // eslint-disable-line

		var colorLight = [
			OAX.style.theme_color.color_light.rgb.r, 
			OAX.style.theme_color.color_light.rgb.g, 
			OAX.style.theme_color.color_light.rgb.b
		];
		var colorDark = [
			OAX.style.theme_color.color_dark.rgb.r, 
			OAX.style.theme_color.color_dark.rgb.g, 
			OAX.style.theme_color.color_dark.rgb.b
		];		

		const imageData = context.getImageData( 0, 0, canvas.width, canvas.height );
		const data = imageData.data;

		for ( let i = 0; i < data.length; i += 4 ) {
			let r = data[i]; // red
			let g = data[i + 1]; // green
			let b = data[i + 2]; // blue

			const bri = ( r + g + b ) / 3 / 255;

			r = colorLight[0] * bri + colorDark[0] * ( 1 - bri );
			g = colorLight[1] * bri + colorDark[1] * ( 1 - bri );
			b = colorLight[2] * bri + colorDark[2] * ( 1 - bri );

			data[i] = r;
			data[i + 1] = g;
			data[i + 2] = b;
		}
		context.putImageData( imageData, 0, 0 );
		imageContainer.addClass( 'is-canvas-filter' );
	},

	initGlueButton( container ){
		const $el = jQuery( container ).find( '.js--btn-glue' );
	},

	initVideos() {

	},

	progressBar( action ) {
		if ( action === 'start' ){
			Pace.restart();
		} else if ( action === 'stop' ){
			// Pace.stop();
		}
	},
	
	debounce ( func, wait ) {
		// we need to save these in the closure
		var timeout, 
			args, 
			context, 
			timestamp;
		
		return function() {
			// save details of latest call
			context = this; // eslint-disable-line
			args = [].slice.call( arguments, 0 ); // eslint-disable-line
			timestamp = new Date();
		
			// this is where the magic happens
			var later = function() { // eslint-disable-line
				// how long ago was the last call
				var last = new Date() - timestamp;

				/*
				 * if the latest call was less that the wait period ago
				 * then we reset the timeout to wait for the difference
				 */
				if ( last < wait ) {
					timeout = setTimeout( later, wait - last );
		
				// or if not we can null out the timer and run the latest
				} else {
					timeout = null;
					func.apply( context, args ); // eslint-disable-line
				}
			};

			// we only need to set the timer now if one isn't already running
			if ( ! timeout ) {
				timeout = setTimeout( later, wait );
			}
		};
	},	

	responsiveIframes( container ){
		const self = this;
		const $iframes = jQuery( container ).find( 'iframe' );

		$iframes.each( ( index, el ) => {
			const height = jQuery( el ).height(),
				width = jQuery( el ).width();
			
			let ratio = height / width * 100;
			const srcAttr = jQuery( el ).attr( 'src' );
			
			if ( srcAttr.indexOf( 'youtube' ) !== -1 || srcAttr.indexOf( 'youtu.be' ) !== -1 ){
				ratio = 9 / 16 * 100; // 16/9				
				if ( srcAttr.indexOf( 'nocookie' ) === -1 ) {
					self.injectYT( el );
				}				
			}

			jQuery( el ).addClass( 'absolute left-0 top-0 w-full h-full' );
			jQuery( el ).wrap( `<div class="c-iframe relative bg-theme-base-2" style="padding-bottom: ${ratio}%"></div>` );			
		} );
	},

	injectYT( _container ) {
		const container = this.isset( _container ) ? _container : document;
		const youtube = container.querySelectorAll( '.js--yt' );	    
		if ( $( youtube ).length > 0 ){
			for ( var i = 0; i < youtube.length; i++ ) {
				/*
				 * Medium Quality: http://img.youtube.com/vi/{video-id}/mqdefault.jpg (320×180 pixels)
				 * High Quality: http://img.youtube.com/vi/G0wGs3useV8/hqdefault.jpg (480×360 pixels)
				 * Standard Definition (SD): http://img.youtube.com/vi/G0wGs3useV8/sddefault.jpg (640×480 pixels)
				 * Maximum Resolution: http://img.youtube.com/vi/G0wGs3useV8/maxresdefault.jpg (1920×1080 pixels)			        
				 */
				const source = `https://img.youtube.com/vi/${$( youtube[i] ).data( 'embed' )}/sddefault.jpg`;
				const image = new Image();
        
				image.src = source;
				$( image ).addClass( 'c-yt__poster absolute left-0 top-0 w-full h-full object-fit-cover' );
				image.addEventListener( 'load', ( function() { // eslint-disable-line
					youtube[ i ].appendChild( image );
				}( i ) ) );

				youtube[i].addEventListener( 'click', (event) => { // eslint-disable-line
					const iframe = document.createElement( 'iframe' );
					const $target = $( event.target ).is( '.js--yt' ) ? $( event.target ) : $( event.target ).closest( '.js--yt' );

					iframe.setAttribute( 'frameborder', '0' );
					iframe.setAttribute( 'allowfullscreen', '' );
					$( iframe ).addClass( 'c-yt__iframe absolute left-0 top-0 w-full h-full' );
					iframe.setAttribute( 'src', `https://www.youtube.com/embed/${$target.data( 'embed' )}?rel=0&showinfo=0&autoplay=1` );
					
					$target.html( '' );
					$target.append( iframe );
				} );
				
				$( youtube[i] ).append( '<div class="js--yt__play-button"></div>' );
			}
		} else if ( $( container ).is( 'iframe' ) ) {
			const $iframe = $( container );
			const youtubeParser = ( url ) => {
				var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
				var match = url.match( regExp );

				return match && match[7].length === 11 ? match[7] : false;
			};
			const ytVideoId = youtubeParser( $iframe.attr( 'src' ) );
			// get videId from youtube url
			if ( ytVideoId ) {
				$iframe.attr( 'src', `https://www.youtube-nocookie.com/embed/${ytVideoId}` );
			}
		}		
	},	

	injectSVG( container, selector ){
		const injectEls = container.querySelectorAll( typeof selector === 'undefined' ? '.js--svg-inject' : selector );
		
		if ( jQuery( injectEls ).length ){
			SVGInjector( injectEls, { // eslint-disable-line
				each( svg ){
					jQuery( container ).trigger( 'OAX::svg-loaded:single', [svg] );
				}
			}, ( totalSVGsInjected ) => {
				jQuery( container ).trigger( 'OAX::svg-loaded:all', [totalSVGsInjected ] );
			} );
		}
	},

	getCurrentDate(){
		var today = new Date();
		var dd = today.getDate();
		var mm = today.getMonth() + 1; // January is 0!
		var yyyy = today.getFullYear();
	
		if ( dd < 10 ) {
			dd = `0${dd}`; 
		} 		
		if ( mm < 10 ) {
			mm = `0${mm}`; 
		} 
	
		today = `${yyyy}-${mm}-${dd}`;	
	
		return today;
	},

	timelinePromise( timeline, onUpdateParam ) {
		const _onUpdateParam = typeof onUpdateParam === 'undefined' ? false : onUpdateParam, 
			_oldOnComplete = typeof timeline.vars.onComplete !== 'undefined' ? timeline.vars.onComplete : false;
		
		let _triggerPromise = true;

		return new Promise( ( resolve ) => {
			if ( _onUpdateParam === false ){
				// alternate syntax for adding a callback
				timeline.eventCallback( 'onComplete', () => {
					if ( _oldOnComplete !== false ) {
						_oldOnComplete();
					}
					resolve( true );
				} );
			} else if ( jQuery.isNumeric( _onUpdateParam ) ){
				timeline.eventCallback( 'onUpdate', ( tl ) => {
					var fxd = tl.progress().toFixed( 1 );
					if ( fxd == _onUpdateParam && _triggerPromise ){ // eslint-disable-line
						_triggerPromise = false;

						if ( _oldOnComplete !== false ) {
							_oldOnComplete();
						}
						resolve( true );
					}
					if ( fxd == _onUpdateParam + 0.1 && _triggerPromise ){ // eslint-disable-line
						if ( _oldOnComplete !== false ) {
							_oldOnComplete();
						}
						resolve( true );
					}
				}, ['{self}'] );
				timeline.eventCallback( 'onComplete', () => {} );
			}
		} );
	},

	loadScript( url ){
		const scriptPromise = new Promise( ( resolve, reject ) => {
			const scripts = document.getElementsByTagName( 'script' ),
				desiredSource = url;
			let alreadyLoaded = false;
			
			if ( scripts.length ){
				for ( var scriptIndex in scripts ) { // eslint-disable-line
					if ( ! alreadyLoaded && desiredSource === scripts[scriptIndex].src ) {
						alreadyLoaded = true;
						resolve( true );
					}
				}
			}

			if ( ! alreadyLoaded ){
				const script = document.createElement( 'script' );
				document.head.appendChild( script );
				script.onload = resolve;
				script.onerror = reject;
				// script.async = true;
				script.src = url;
			}
		} );
    
		return scriptPromise;    
	},

	getComputedStyle( $el, value ){
		return window.getComputedStyle( $el instanceof jQuery ? $el.get( 0 ) : $el, null ).getPropertyValue( value );
	},

	loadSVG( url ){
		return fetch( url )
			.then( ( response ) => response.text() );
	},

	onTransitionEnd(){
		return 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
	},

	onAnimationIteration(){
		return 'MSAnimationIteration webkitAnimationIteration animationiteration';
	},

	goToUrl( url ){
		Barba.Pjax.goTo( url );
	},

	isMobile(){
		return ! Modernizr.mq( '(min-width: 992px)' );
	}
};

window.OAX = window.OAX || {};
window.OAX.UTILS = Utils;

export default Utils;
